<template>
  <div>
    <div class="content">
      <el-tabs v-model="activeName">
        <el-tab-pane label="承包商列表" name="first">
          <div v-if="activeName === 'first'">
            <contracor></contracor>
          </div>
        </el-tab-pane>
        <el-tab-pane label="供应商列表" name="second">
          <div v-if="activeName === 'second'">
            <supplier></supplier>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import contracor from "./ContractorManagementComponents/contractor"
import contractPersonList from "./ContractorManagementComponents/contractPersonList.vue"
import supplier from "./supplierManager"
export default {
  name: "contrac",
  components: {
    contracor,
    contractPersonList,
    supplier
  },
  data() {
    return {
      activeName: 'first'
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  border: 1px solid #e9eef3;
}
</style>
